function useInputAddonStyles() {
  const baseStyles = "flex h-9 shrink-0 items-center text-sm text-gray-600 dark:text-gray-400";
  return {
    start: baseStyles + " pl-3",
    end: baseStyles + " pr-3"
  };
}

export { useInputAddonStyles };
